import { GENERATE_REPORT, GENERATE_REPORT_FAILURE, GENERATE_REPORT_SUCCESS, GET_ASSIGN_INCIDENT_DETAIL, GET_ASSIGN_INCIDENT_DETAIL_CLEANER, GET_ASSIGN_INCIDENT_DETAIL_FAILURE, GET_ASSIGN_INCIDENT_DETAIL_SUCCESS, GET_MANAGE_INCIDENTS, GET_MANAGE_INCIDENTS_DETAIL, GET_MANAGE_INCIDENTS_DETAIL_FAILURE, GET_MANAGE_INCIDENTS_DETAIL_SUCCESS, GET_MANAGE_INCIDENTS_FAILURE, GET_MANAGE_INCIDENTS_SUCCESS } from '../constants'

export default class ReportAction {
    static GenerateReport(payload) {
        console.log(payload)
        return {
            type: GENERATE_REPORT,
            payload
        }
    }

    static GenerateReportSuccess(payload) {
        console.log(payload)
        return {
            type: GENERATE_REPORT_SUCCESS,
            payload
        }
    }

    static GenerateReportFailure() {
        return {
            type: GENERATE_REPORT_FAILURE
        }
    }
}